const scrollWindowTo = (top: number, behavior: ScrollBehavior) => {
    window.scrollTo({ top, behavior });
};

export const scrollToTop = (behavior: ScrollBehavior = "smooth") => {
    scrollWindowTo(0, behavior);
};

export const scrollToTopAfterFilter = () => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            scrollWindowTo(0, "auto");
        });
    });
};
